import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataCustomerTypesActions } from "./customer-types.actions";

// **************************************************************************
// CUSTOMER TYPES REDUCER
// **************************************************************************

const load = on(DataCustomerTypesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        customerType: {
            ...state.data.customerType,
            customerTypesLoading: true,
        },
    },
}));

const loadSuccess = on(DataCustomerTypesActions.loadSuccess, (state: ApplicationStore, { customerTypes }) => ({
    ...state,
    data: {
        ...state.data,
        customerType: {
            ...state.data.customerType,
            customerTypes,
            customerTypesLoading: false,
        },
    },
}));

const loadFailure = on(DataCustomerTypesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        customerType: {
            ...state.data.customerType,
            customerTypesLoading: false,
        },
    },
}));

export const customerTypesReducer = [load, loadSuccess, loadFailure];
